import type { FaireProductEntity } from "../../entity_types/product";

export const p_q3jmhssqu9: FaireProductEntity = {
  token: "p_q3jmhssqu9",
  type: "product",
  name: "Marble Candle- White Label Ready",
  brandToken: "b_h2nuzyq4qg",
  brandName: "Standard Wax",
  imageUrl:
    "https://cdn.faire.com/fastly/dcdb6cd784f756ccf011ff33cadf8e523ff78c1d60a098bc3ceee579f5ec044b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e1a09668baba8b98d37b5d4f669d7d36d039012314961a8e257bcf6b37ac69ca.jpeg",
    "https://cdn.faire.com/fastly/5a20efa3fc316c1068c514b142ff86bf481594c859acde88b7b7586828e8f1d1.jpeg",
    "https://cdn.faire.com/fastly/6a77848dbd66d0d44cd0057ae8c1ca574ae77b82cb51d6cd088cbbfa86c88d08.png",
    "https://cdn.faire.com/fastly/53921aebe9b36d556a075522ed28557d82e8cb35cac920261989804fb2181162.jpeg",
    "https://cdn.faire.com/fastly/da8d13a1dcca9ca04c3716929f1ef061e992aa9482eff0b0c7d291e7518f14dc.jpeg",
    "https://cdn.faire.com/fastly/6ef9685e14bab079c9b1f0ac7652f3d7b5ca9f63cea7c958ee9784eca24011a0.jpeg",
    "https://cdn.faire.com/fastly/e05af6706583130e2df2aad1facc3a410b31b3466bf181f23d412999c60a8ab7.jpeg",
    "https://cdn.faire.com/fastly/305ec4993347a7e315b98be9af6b98bd6fba2265ed9ab98432a3bc39c106bc6a.jpeg",
    "https://cdn.faire.com/fastly/6a59787bdb6b73867d8753babec256c24ccdabd9e475bf165d28c9fa0697810e.jpeg",
    "https://cdn.faire.com/fastly/c627cb3d207b5f6647bc73347d19c6401e9281ba6dabf77f072379369c96cbe3.jpeg",
  ],
  priceDollars: 47,
  description:
    'Each candle is thoughtfully hand-poured by me, the owner (Liz), in Northwest Ohio, where craftsmanship and attention to detail are at the heart of every piece.\n\nInspired by my love for interior design, I create candles that go beyond fragrance, each one is designed to feel like a statement piece within your home. Sculptural, refined, and intentional, they’re meant to complement your space as beautifully as they scent it.\nStandard Wax candles are designed to elevate everyday moments — bringing warmth, atmosphere, and effortless luxury to any room.\n\nEach vessel is crafted from genuine marble, resulting in natural variations in color and marbling—no two are exactly alike.\nCapacity: 13 oz.\nMaterial: Natural marble\nWax: 100% soy wax, hand-poured\nBurn Time: Approximately 75+ hours\nDimensions: 4.125" H × 3.5" W × 3.5" L\n\nCustomization Options:\nSelect your vessel color\nSelect your scent (samples available via our scent kit)\n\nPackaging:\nStandard cardboard packaging included. Custom labeling is available for bulk orders of 36 or more.\n\nPlease Note:\nAll candles are made to order. Due to the custom nature of this product, returns are not accepted. Natural variations in marble should be expected.',
  tags: [],
  msrpDollars: 94,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:48:00.700Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
